import React, { FC } from 'react';
// import { motion } from 'framer-motion';
import s from './IframeBlock.module.css';
import { IframeBlockProps } from '@/types/model';

const IframeBlock: FC<IframeBlockProps> = ({ url }) => {
  return <iframe className={s.container} src={url} sandbox="allow-scripts allow-same-origin" />;
};

export default IframeBlock;
